import React from 'react';
import ContentPageHeader from './PageHeader';
import CommandEditor from './CommandEditor';
import { useContent } from '../contexts/ContentContext';

const TwitchGuide: React.FC = () => {
  const { content, language } = useContent();
  const guide = content.ui[language].guide;
  const streamUrl = content.home.streamUrl.replace(/\/$/, '');
  return <div className="lab-page lab-guide lab-content-page">
    <ContentPageHeader description={guide.lead} />
    <div className="lab-section grid md:grid-cols-2 gap-8">
      <section className="space-y-4"><h2>{guide.watchTitle}</h2><p>{guide.status}</p>{streamUrl ? <a className="lab-button" href={streamUrl} target="_blank" rel="noopener noreferrer">{guide.watch}</a> : <p role="status">{guide.missing}</p>}</section>
      <section className="space-y-4"><h2>{guide.archiveTitle}</h2><p>{guide.archiveLead}</p>{streamUrl ? <a className="lab-button" href={streamUrl + '/videos'} target="_blank" rel="noopener noreferrer">{guide.archive}</a> : <p>{guide.missingArchive}</p>}</section>
    </div>
    <nav aria-label={guide.related} className="lab-section flex flex-wrap gap-3"><a className="lab-button" href="/?page=gallery">{guide.images}</a><a className="lab-button" href="/?page=gallery&tab=works">{guide.works}</a><a className="lab-button" href="/?page=article">{guide.notes}</a><a className="lab-button" href="#command-editor">{guide.commands}</a></nav>
    <div id="command-editor" className="lab-section"><CommandEditor /></div>
  </div>;
};
export default TwitchGuide;
